import { observable, action } from 'mobx';

import { Variables, ConnectionAppManager, AppRegistry } from 'core/index';

import { ProjectArrayApp } from 'apps/project/app';
import { ProfileProjectsQuery } from 'apps/project/gql';

import i18next from 'i18next';

export class ProjectConnManager extends ConnectionAppManager {
  static registryName = 'ProjectConnManager';
  static ArrayApp = ProjectArrayApp;
  @observable sortBy;
  @observable sortOptions;
  @observable filterBy;
  @observable containsBy;
  @observable startsBy;

  constructor(parent, init, options) {
    super(parent, init, options);
    this.initialBatchSize =
      init.initialBatchSize || this.arrayApp.cardLayout.initialBatchSize;
    this.batchSize = init.batchSize || this.arrayApp.cardLayout.batchSize;
    this.sortBy = init.sortBy || 'recent';
    this.sortOptions = init.sortOptions || [
      ['recent', i18next.t('Recent')],
      ['-stars', i18next.t('Stars')],
      ['contributions', i18next.t('Contributions')],
    ];
    this.filterBy = init.filterBy || [];
    this.containsBy = init.containsBy || [];
    this.startsBy = init.startsBy || [];
    this.contains = init.contains || [];
    this.notContains = init.notContains || [];
    this.whitelabels = init.whitelabels || [];
    this.variables = new Variables({
      sortBy: () => this.sortBy,
      batchSize: () => {
        if (this.loadedMore) {
          return this.batchSize;
        }
        return this.initialBatchSize;
      },
      featuredProjectsCount: () => {
        if (this.loadedMore) {
          return this.batchSize;
        }
        return this.initialBatchSize;
      },
      cursor: () => this.endCursor,
      featuredProjectsCursor: () => this.endCursor,
      filterBy: () => this.filterBy,
      containsBy: () => this.containsBy,
      startsBy: () => this.startsBy,
      contains: () => this.contains,
      notContains: () => this.notContains,
      whitelabels: () => this.whitelabels,
    });
    this.loadMoreQuery = init.loadMoreQuery || ProfileProjectsQuery;

    this.variables.onChange(
      ['filterBy', 'containsBy', 'startsBy'],
      this.newFilter,
      { fireImmediately: false },
    );
  }

  @action newFilter = () => {
    this.Reset();
    this.loadMore();
  };

  @action NewUsername() {
    this.Reset();
  }

  @action SetSort(sort) {
    this.sortBy = sort;
    this.Clear();
    this.loadMore();
  }

  @action SetFilter(filter) {
    this.filterBy = filter;
    this.Clear();
    this.loadMore();
  }
}
AppRegistry.add(ProjectConnManager);

export class SuggestedProjectConnManager extends ConnectionAppManager {
  static registryName = 'SuggestedProjectConnManager';

  static ArrayApp = ProjectArrayApp;

  constructor(parent, init) {
    super(parent, init);
    this.batchSize = init.batchSize || this.arrayApp.cardLayout.batchSize;
    this.projectId = init.projectId;
    this.initialBatchSize = this.batchSize;

    this.variables = new Variables({
      batchSize: () => {
        if (this.loadedMore) {
          return this.batchSize;
        }
        return this.initialBatchSize;
      },
      cursor: () => this.endCursor,
      projectId: this.projectId,
    });

    this.loadMoreQuery = init.loadMoreQuery;
  }
}

AppRegistry.add(SuggestedProjectConnManager);
